// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"9dc2ec4a","279":"c0422158","283":"0e6b0778","663":"be892637","683":"c0422158","925":"a45ceb7d","982":"87fbbfa2"}[chunkId] + ".chunk.css";
};